/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface ValidationErrorInfo {
  cause?: {
    stackTrace?: {
      classLoaderName?: string;
      moduleName?: string;
      moduleVersion?: string;
      methodName?: string;
      fileName?: string;
      lineNumber?: number;
      className?: string;
      nativeMethod?: boolean;
    }[];
    message?: string;
    suppressed?: {
      stackTrace?: {
        classLoaderName?: string;
        moduleName?: string;
        moduleVersion?: string;
        methodName?: string;
        fileName?: string;
        lineNumber?: number;
        className?: string;
        nativeMethod?: boolean;
      }[];
      message?: string;
      localizedMessage?: string;
    }[];
    localizedMessage?: string;
  };
  stackTrace?: {
    classLoaderName?: string;
    moduleName?: string;
    moduleVersion?: string;
    methodName?: string;
    fileName?: string;
    lineNumber?: number;
    className?: string;
    nativeMethod?: boolean;
  }[];

  /**
   * Сообщение об ошибки
   * @example Ошибка валидации
   */
  message: string;

  /** Код ошибки */
  errorCode: "VALIDATION_ERROR";

  /** Развернутое описание ошибки/ок */
  errorDetails: ValidationFieldInfo[];
  suppressed?: {
    stackTrace?: {
      classLoaderName?: string;
      moduleName?: string;
      moduleVersion?: string;
      methodName?: string;
      fileName?: string;
      lineNumber?: number;
      className?: string;
      nativeMethod?: boolean;
    }[];
    message?: string;
    localizedMessage?: string;
  }[];
  localizedMessage?: string;
}

/**
 * Объект для представления ошибки
 */
export interface ValidationFieldInfo {
  /**
   * Имя поля
   * @example accountNumber
   */
  fieldName: string;

  /**
   * Сообщение об ошибки
   * @example Неверный номер счета(длина не соответствует требованиям)
   */
  message: string;

  /**
   * Переданное не верное значение
   * @example 408178L0099910004312
   */
  rejectValue: string;
}

/**
 * Список ошибок
 */
export interface ErrorList {
  /** Ошибки */
  Error?: IntegrationSimpleErrorDataType[];
}

/**
 * Ошибка
 */
export interface IntegrationSimpleErrorDataType {
  /** Код ошибки */
  ErrorCode?: string;

  /** Описание ошибки */
  ErrorDesc?: string;
}

/**
 * Идентификатор заявки в ККР ЮЛ
 */
export interface IntegrationSymbolicIdentifierXType {
  /** Символьный идентификатор объекта */
  ObjectId?: string;

  /** Идентификатор системы/приложения, в контексте которой существует идентификатор объекта */
  SystemId?: string;

  /** Идентификатор узла/экземпляра системы/приложения, в контексте которой существует идентификатор объекта */
  SystemNodeId?: string;
}

/**
 * Ответ из ККР
 */
export interface KkrResponse {
  /** Признак успешности обработки запроса */
  IsSuccessResult?: boolean;

  /** Идентификатор заявки в ККР ЮЛ */
  ApplicationKKRLEId?: IntegrationSymbolicIdentifierXType;

  /** Идентификатор заявки в ККР ЮЛ */
  ApplicationNDBOLEId?: IntegrationSymbolicIdentifierXType;

  /** Список ошибок */
  ErrorList?: ErrorList;
}

/**
 * Ошибка на стороне сервиса
 */
export interface GenericError {
  /** Название ошибки */
  name?: string;

  /** Описание ошибки */
  description?: string;

  /** Дата и время возникновения ошибки */
  timestamp?: string;
}

/**
 * Описание статуса заявки
 */
export enum ApplicationStatusDescEnum {
  EMPTY_DESC = "EMPTY_DESC",
  REJECTDESC1 = "REJECT_DESC_1",
  REJECTDESC2 = "REJECT_DESC_2",
  REJECTDESC3 = "REJECT_DESC_3",
  REJECTDESC4 = "REJECT_DESC_4",
  REJECTDESC5 = "REJECT_DESC_5",
  REJECTDESC6 = "REJECT_DESC_6",
  REJECTDESC7 = "REJECT_DESC_7",
  REJECTDESC8 = "REJECT_DESC_8",
  REJECTDESC9 = "REJECT_DESC_9",
  REJECTDESC10 = "REJECT_DESC_10",
  RECEIVED_DESC = "RECEIVED_DESC",
  CHECK_FORM_DESC = "CHECK_FORM_DESC",
  CHECK_DOCS_DESC = "CHECK_DOCS_DESC",
  REWRITE_DESC = "REWRITE_DESC",
  NEED_DOCS_DESC = "NEED_DOCS_DESC",
  VIRUS = "VIRUS",
  ERROR = "ERROR",
  CREATE_PRINTFORMS_DESC = "CREATE_PRINTFORMS_DESC",
  WRITE_PRINTFORMS_DESC = "WRITE_PRINTFORMS_DESC",
  RECEIVED_PRINTFORMS_DESC = "RECEIVED_PRINTFORMS_DESC",
  EXECUTED_DESC = "EXECUTED_DESC",
}

/**
 * Статус заявки
 */
export enum ApplicationStatusEnum {
  NEW = "NEW",
  PREPARED = "PREPARED",
  ACCEPTED = "ACCEPTED",
  PRE_PROCESSING = "PRE_PROCESSING",
  PROCESSING = "PROCESSING",
  RECEIVED = "RECEIVED",
  CHECK_FORM = "CHECK_FORM",
  CHECK_DOCS = "CHECK_DOCS",
  REWRITE = "REWRITE",
  NEED_DOCS = "NEED_DOCS",
  HOLD = "HOLD",
  REJECT = "REJECT",
  CREATE_PRINTFORMS = "CREATE_PRINTFORMS",
  WRITE_PRINTFORMS = "WRITE_PRINTFORMS",
  RECEIVED_PRINTFORMS = "RECEIVED_PRINTFORMS",
  EXECUTED = "EXECUTED",
}

/**
 * Адрес регистрации заемщика
 */
export interface BorrowerAddress {
  /** Признак совпадения адреса регистрации заемщика */
  residenceIsRegistration?: boolean;

  /** Индекс (прописка) */
  residencePostalCode?: string;

  /** Респ./область/край  */
  residenceProvance?: string;

  /** Район */
  residenceDistrict?: string;

  /** Город */
  residenceCity?: string;

  /** Населенный пункт */
  residenceCounty?: string;

  /** Улица */
  residenceStreet?: string;

  /** Дом */
  residenceHouse?: string;

  /** Строение / Корпус */
  residenceBuilding?: string;

  /** Офис / Кв / Комната */
  residenceApartment?: string;
}

/**
 * Адрес фактического проживания
 */
export interface BorrowerAddressFact {
  /** Признак совпадения фактического адреса проживания с адресом регистрации бизнеса */
  stayIsRegistration?: boolean;

  /** Индекс (прописка) */
  stayPostalCode?: string;

  /** Респ./область/край  */
  stayProvance?: string;

  /** Район */
  stayDistrict?: string;

  /** Город */
  stayCity?: string;

  /** Населенный пункт */
  stayCounty?: string;

  /** Улица */
  stayStreet?: string;

  /** Дом */
  stayHouse?: string;

  /** Строение / Корпус */
  stayBuilding?: string;

  /** Офис / Кв / Комната */
  stayApartment?: string;
}

/**
 * Данные о компании
 */
export interface BorrowerCompany {
  /** Система налогообложения */
  taxSystem: string;

  /** Основной ОКВЭД (код) */
  basicOkvedCode: string;

  /** Основной ОКВЭД (наименование) */
  basicOkvedName?: string;

  /** Номер лицензии основного  вида деятельности */
  basicActivityLicenseNumber?: string;

  /**
   * Срок действия (дата окончания)
   * @format date
   */
  basicActivityEndDate?: string;

  /** Фактический ОКВЭД (код) */
  actualOkvedCode?: string;

  /** Фактический ОКВЭД (наименование) */
  actualOkvedName?: string;

  /** Номер лицензии фактического вида деятельности */
  basicActualLicenseNumber?: string;

  /**
   * Срок действия (дата окончания)
   * @format date
   */
  basicActualEndDate?: string;

  /** Полномочия Главы КФК (единолично, неединолично) */
  isSoleAuthority?: SoleAuthorityEnum;
  actualActivityLicensed?: boolean;
  headKFH?: boolean;
  basicActivityLicensed?: boolean;

  /** @format int32 */
  kfhmembers?: number;
}

/**
 * Сведения о заемщике
 */
export interface BorrowerInfo {
  /** ФИО руководителя Клиента */
  fio: string;

  /** Наименование Клиента */
  clientShortName?: string;

  /** Предыдущее ФИО */
  previousFio?: string;

  /**
   * Дата рождения
   * @format date
   */
  birthDate: string;

  /** Место рождения */
  birthPlace: string;

  /** Семейное положение */
  martialStatus:
    | "NOT_MARRIED"
    | "DIVORCED"
    | "WIDOW"
    | "CIVIL_MARRIAGE"
    | "MARRIED";

  /** ФИО супруга/и */
  spouseFio?: string;

  /**
   * Дата регистрации Клиента
   * @format date
   */
  regDate: string;

  /** ИНН Клиента */
  inn: string;

  /** ОГРН Клиента */
  orgn: string;

  /** Фактический срок ведения деятельности */
  workPeriod: string;
}

/**
 * Адрес ведения бизнеса
 */
export interface BusinessAddress {
  /** Признак совпадения адреса ведения бизнеса  */
  businessIsRegistration?: boolean;

  /** Право собственности на помещение */
  businessOwnership?: string;

  /** Индекс (адрес ведения бизнеса) */
  businessPostalCode?: string;

  /** Респ./область/край  */
  businessProvance?: string;

  /** Район */
  businessDistrict?: string;

  /** Город */
  businessCity?: string;

  /** Населенный пункт */
  businessCounty?: string;

  /** Улица */
  businessStreet?: string;

  /** Дом */
  businessHouse?: string;

  /** Строение / Корпус */
  businessBuilding?: string;

  /** Офис / Кв / Комната */
  businessApartment?: string;
}

/**
 * Адрес регистрации бизнеса
 */
export interface BusinessAddressReg {
  /** Право собственности на помещение */
  registrationOwnership: string;

  /** Индекс (регистрация бизнеса) */
  registrationPostalCode: string;

  /** Респ./область/край  */
  registrationProvance?: string;

  /** Район */
  registrationDistrict?: string;

  /** Город */
  registrationCity?: string;

  /** Населенный пункт */
  registrationCounty?: string;

  /** Улица */
  registrationStreet?: string;

  /** Дом */
  registrationHouse: string;

  /** Строение / Корпус */
  registrationBuilding?: string;

  /** Офис / Кв / Комната */
  registrationApartment?: string;
}

/**
 * Финансы компании
 */
export interface CompanyFinance {
  /** Доход/выручка за I-ый квартал текущего года */
  income_1Quarter: number;

  /** Доход/выручка за II-ый квартал текущего года */
  income_2Quarter: number;

  /** Доход/выручка за III-ый квартал текущего года */
  income_3Quarter: number;

  /** Доход/выручка за IV-ый квартал текущего года */
  income_4Quarter: number;

  /** Прибыль/Убыток за I-ый квартал текущего года */
  revenue_1Quarter: number;

  /** Прибыль/Убыток за II-ый квартал текущего года */
  revenue_2Quarter: number;

  /** Прибыль/Убыток за III-ый квартал текущего года */
  revenue_3Quarter: number;

  /** Прибыль/Убыток за IV-ый квартал текущего года */
  revenue_4Quarter: number;

  /**
   * Отчетная дата дохода за I квартал
   * @format date
   */
  incomeDate_1Quarter: string;

  /**
   * Отчетная дата дохода за II квартал
   * @format date
   */
  incomeDate_2Quarter: string;

  /**
   * Отчетная дата дохода за III квартал
   * @format date
   */
  incomeDate_3Quarter: string;

  /**
   * Отчетная дата дохода за IV квартал
   * @format date
   */
  incomeDate_4Quarter: string;

  /**
   * Отчетная дата прибыли/убытка за I квартал
   * @format date
   */
  revenueDate_1Quarter: string;

  /**
   * Отчетная дата прибыли/убытка за II квартал
   * @format date
   */
  revenueDate_2Quarter: string;

  /**
   * Отчетная дата прибыли/убытка за III квартал
   * @format date
   */
  revenueDate_3Quarter: string;

  /**
   * Отчетная дата прибыли/убытка за IV квартал
   * @format date
   */
  revenueDate_4Quarter: string;
}

/**
 * Контактные данные
 */
export interface Contacts {
  /** ФИО контактного лица */
  contactFullName: string;

  /** Контактный номер телефона */
  contactPhone: string;

  /** Адрес электронной почты */
  contactEmail: string;

  /** Рабочий телефон */
  businessPhone?: string;

  /** Web-сайт */
  webSite?: string;

  /** Должность */
  post: string;
}

/**
 * Анкета
 */
export interface CreditForm {
  /** Сохранить без проверок */
  forceSave?: boolean;

  /** Признак того, что анкета уже отправлялась в ККР */
  hasAlreadyBeenSent?: boolean;

  /** Сведения о заемщике */
  borrowerInfo?: BorrowerInfo;

  /** Адрес регистрации бизнеса */
  businessAddressReg?: BusinessAddressReg;

  /** Адрес ведения бизнеса */
  businessAddress?: BusinessAddress;

  /** Адрес регистрации заемщика */
  borrowerAddress?: BorrowerAddress;

  /** Адрес фактического проживания */
  borrowerAddressFact?: BorrowerAddressFact;

  /** Паспорт */
  passportFront?: PassportFront;

  /** Контактные данные */
  contacts?: Contacts;

  /** Данные о компании */
  borrowerCompany?: BorrowerCompany;

  /** Задолженности */
  debts?: Debts;

  /** Финансы компании */
  companyFinance?: CompanyFinance;

  /** Статус заявки */
  statusForm?: ApplicationStatusEnum;

  /** Описание статуса заявки */
  statusFormDescription?: ApplicationStatusDescEnum;

  /** Список доступных бизнес-операций клиента */
  actorPermissions?: string[];
}

/**
 * Задолженности
 */
export interface Debts {
  /** Сумма картотеки */
  card2Amount?: number;

  /**
   * Дата возникновения картотеки
   * @format date
   */
  card2StartDate?: string;

  /**
   * Дата возникновения задолженности перед бюджетом
   * @format date
   */
  budgetDebtStartDate?: string;

  /**
   * Планируемая дата погашения задолженности перед бюджетом
   * @format date
   */
  budgetDebtRepaymentDate?: string;

  /** Сумма задолженности перед бюджетом */
  budgetDebtAmount?: number;

  /** Предмет задолженности перед бюджетом */
  budgetDebtSubject?: string;

  /** Признак наличия просроченной задолженности перед работниками по заработной плате */
  hasWageDebt?: boolean;

  /**
   * Дата возникновения задолженности по заработной плате
   * @format date
   */
  wageDebtStartDate?: string;

  /**
   * Планируемая дата погашения задолженности по заработной плате
   * @format date
   */
  wageDebtRepaymentDate?: string;

  /** Сумма задолженности по заработной плате */
  wageDebt?: number;

  /**
   * Дата возникновения арестов или иных обременений
   * @format date
   */
  chargeDebtStartDate?: string;

  /**
   * Планируемая дата погашения арестов или иных обременений
   * @format date
   */
  chargeDebtRepaymentDate?: string;

  /** Сумма задолженности по арестам или иным обременениям */
  chargeDebtAmount?: number;

  /** Предмет ареста */
  chargeDebtSubject?: string;

  /** Сумма картотеки по дебиторской задолженности */
  debtorsDebtAmount?: number;

  /**
   * Дата возникновения дебиторской задолженности
   * @format date
   */
  debtorsDebtStartDate?: string;

  /** Сумма картотеки по кредиторской задолженности */
  creditDebtAmount?: number;

  /**
   * Дата возникновения кредиторской задолженности
   * @format date
   */
  creditDebtStartDate?: string;
  creditDebt?: boolean;
  card2?: boolean;
  budgetDebt?: boolean;
  debtorsDebt?: boolean;
  chargeDebt?: boolean;
}

/**
 * Паспорт
 */
export interface PassportFront {
  /** Тип документа удостоверяющего личность */
  dulName: string;

  /** Серия документа удостоверяющего личность */
  dulSeries: string;

  /** Номер документа удостоверяющего личность */
  dulNumber: string;

  /** Орган, выдавший документ удостоверяющий личность */
  dulIssueCode: string;

  /**
   * Дата документа удостоверяющего личность
   * @format date
   */
  dulIssueDate: string;

  /** Код подразделения, выдавшеого документ удостоверяющий личность */
  dulIssueDep: string;
}

/**
 * Полномочия Главы КФК (единолично, неединолично)
 */
export enum SoleAuthorityEnum {
  SOLELY = "SOLELY",
  NOT_SOLELY = "NOT_SOLELY",
}

/**
 * Пусто ok-ответ
 */
export type EmptyResponse = object;

/**
 * Тип документа. Соответствует DocumentCodeEnum
 */
export enum DocumentCodeEnum {
  DECLARATION = "DECLARATION",
  PASSPORT = "PASSPORT",
  APPLICATION = "APPLICATION",
  BKI = "BKI",
}

/**
 * Тип файла
 */
export enum FileTypeEnum {
  FILE = "FILE",
  SIGNATURE = "SIGNATURE",
}

/**
 * Объект файла загрузки
 */
export interface UploadFileReq {
  /**
   * ID заявки
   * @format uuid
   */
  applicationId?: string;

  /** Тип файла */
  contentType?: string;

  /** Содержимое в base64 */
  data?: string;

  /** Название файла */
  fileName?: string;

  /** Тип файла */
  fileType?: FileTypeEnum;

  /** Тип документа. Соответствует DocumentCodeEnum */
  documentCode?: DocumentCodeEnum;

  /**
   * ID подписываемого файла, если это подпись
   * @format uuid
   */
  signedFileId?: string;

  /** Серийный номер сертификата, если это подпись */
  certificateNumber?: string;
}

/**
 * Объект ответа по загружаемому файлу
 */
export interface UploadFileResp {
  /** Код ошибки */
  errorCode?: string;

  /** Описание ошибки */
  errorDescription?: string;

  /**
   * UID файла
   * @format uuid
   */
  fileId?: string;
}

/**
 * Список адресов
 */
export interface AddresListResp {
  /** Список адресов */
  suggestions?: Suggestions[];
}

/**
 * Предложенные значения адресов
 */
export interface DataFields {
  /** Индекс */
  postal_code?: string;

  /** Регион (область) */
  region?: string;

  /** Район */
  area?: string;

  /** Город */
  city?: string;

  /** Населенный пункт */
  settlement?: string;

  /** Улица */
  street?: string;

  /** Дом */
  house?: string;

  /** Корпус */
  block?: string;

  /** Квартира */
  flat?: string;
}

/**
 * Предложенные значения адресов
 */
export interface Suggestions {
  /** Адрес */
  unrestricted_value?: string;

  /** Предложенные значения адресов */
  data?: DataFields;
}

/**
 * Объект для детальной информации по заявке для фронта
 */
export interface CreditApplicationMainFieldsResp {
  /**
   * ID кредитного продукта
   * @format uuid
   */
  id: string;

  /** Запрашиваемая сумма кредита */
  requestAmount: number;

  /**
   * Запрашиваемый срок кредита
   * @format int32
   */
  period: number;

  /** Фактический ОКВЭД (код) */
  actualOkvedCode: string;

  /** Фактический ОКВЭД (наименование) */
  actualOkvedName: string;

  /**
   * Дата годовой отчетности
   * @format date-time
   */
  revenueDate: string;

  /** Сумма выручки (баланса) */
  revenueAmount: number;

  /** ФИО контактного лица */
  contactFullName: string;

  /** Контактный номер телефона */
  contactPhone: string;

  /** email */
  email?: string;

  /** Должность */
  post?: string;

  /**
   * Кредитный продукт
   * @format uuid
   */
  product: string;
}

/**
 * Кредитный продукт
 */
export interface CreditProductFront {
  /**
   * Первичный ключ
   * @format uuid
   */
  id: string;

  /** Название кредитного продукта */
  name: string;

  /** Описание кредитного продукта */
  description: string;

  /** Сегмент Клиентов, для которых доступен кредитный продукт */
  segment?: string;

  /** Валюта кредита */
  currency: string;

  /** Минимальная сумма */
  minAmount: number;

  /** Максимальная сумма */
  maxAmount: number;

  /**
   * Минимальный срок
   * @format int32
   */
  minPeriod: number;

  /**
   * Максимальный срок
   * @format int32
   */
  maxPeriod: number;

  /** Ставка */
  rate: string;
  opf?: string;
}

/**
 * Ответ по списку кредитных продуктов
 */
export interface CreditProductsListResp {
  /** Список кредитных продуктов */
  creditProductsList?: CreditProductFront[];
  okved?: Okved[];
}

/**
 * ОКВЭД
 */
export interface Okved {
  /** Код */
  okvedCode?: string;

  /** Наименование */
  okvedName?: string;
}

/**
 * Основные поля кредитов
 */
export interface CreditMain {
  /** Идентификатор кредитного продукта */
  productId?: string;

  /** Название кредитного продукта */
  creditName?: string;

  /**
   * Процентная ставка
   * @format double
   */
  interestRate?: number;

  /** Номер договора */
  contractNumber?: string;

  /** Сумма */
  creditAmount?: number;

  /**
   * Дата окончания договора
   * @format date-time
   */
  dateExpiration?: string;

  /** ISO-код валюты кредитного договора */
  currency?: string;

  /**
   * Срок лет
   * @format int32
   */
  termYear?: number;

  /**
   * Срок месяцев
   * @format int32
   */
  termMonth?: number;

  /**
   * Срок дней
   * @format int32
   */
  termDay?: number;

  /** Сумма остатка общей просроченной задолженности */
  currentDebtRest?: number;
}

/**
 * Объект для ответа о кредитах
 */
export interface CreditShort {
  /** Основные поля кредитов */
  creditMain?: CreditMain;

  /**
   * Следующий платеж
   * @format date-time
   */
  dateNextPay?: string;

  /** Сумма платежа */
  amountNextPay?: number;
}

/**
 * Объект для ответа о истории документов
 */
export interface CreditShortResponse {
  /** Список кредитов */
  creditList?: CreditShort[];

  /** Есть ли еще документы */
  hasMore?: boolean;

  /**
   * Количество кредитов
   * @format int32
   */
  creditsCount?: number;
}

/**
 * Объект для ответа c детальной информацией о кредите
 */
export interface CreditDetailsInfo {
  /** Основные поля кредитов */
  creditMain?: CreditMain;

  /** Название клиента */
  clientName?: string;

  /** Статус */
  status?: string;

  /** Сумма неиспользованного лимита */
  creditLimitAmount?: number;

  /**
   * Дата заключения договора
   * @format date-time
   */
  dateConclusion?: string;

  /**
   * Дата закрытия. Запонена, если кредит закрыт
   * @format date-time
   */
  dateClose?: string;

  /** Счет погашения */
  repaymentAccount?: string;

  /**
   * Следующий платеж (Дата)
   * @format date-time
   */
  dateNextPay?: string;

  /** Сумма платежа */
  amountNextPay?: number;

  /** Основной долг */
  debtAmountNextPay?: number;

  /** Проценты */
  percentAmountNextPay?: number;

  /** Осталось вылатить */
  payRemainingDebtPercent?: number;

  /** Сумма остатка ссудной задолженности */
  payRemainingDebt?: number;

  /** Сумма остатка задолженности по процентам */
  payRemainingPercent?: number;

  /** Сумма задолженности */
  loanDebtPercentRest?: number;

  /** Сумма остатка просроченной задолженности по основному долгу */
  loanDebtRest?: number;

  /** Сумма остатка просроченной задолженности по процентам */
  loanPercentRest?: number;

  /** Пени/штрафы */
  penalty?: number;

  /** Комиссии */
  commissions?: number;

  /** Госпошлины */
  fees?: number;
}

/**
 * Объект для ответа c графиком платежей по кредиту
 */
export interface CreditPaymentsSchedule {
  /** Номер договора */
  contractNumber?: string;

  /** Валюта */
  currency?: string;

  /** Список платежей */
  paymentDetailsList?: Record<string, PaymentDetails[]>;
}

/**
 * Информация о платеже по кредиту
 */
export interface PaymentDetails {
  /**
   * Дата платежа
   * @format date-time
   */
  paymentDate?: string;

  /** Сумма платежа */
  paymentAmount?: number;

  /** Основной долг */
  debtAmount?: number;

  /** Проценты */
  percentAmount?: number;

  /** Сумма остатка ссудной задолженности */
  remainingDebtAmount?: number;
}

/**
 * Признак права подписи
 */
export enum RightToSignEnum {
  IS_HEAD = "IS_HEAD",
  IS_NOT_HEAD = "IS_NOT_HEAD",
  HEAD_WITHOUT_SIGN = "HEAD_WITHOUT_SIGN",
}

/**
 * Объект ответа по праву подписи
 */
export interface RightToSignResp {
  /** Признак права подписи */
  rightToSign?: RightToSignEnum;

  /** ФИО руководителя (в случае rightToSign = IS_NOT_HEAD) */
  headFio?: string;
}

/**
 * Файл приложенный к анкете
 */
export interface CreditFormFile {
  /**
   * ID файла
   * @format uuid
   */
  id?: string;

  /** Имя файла */
  fileName?: string;

  /** Статус */
  status?:
    | "LOADED"
    | "CHECKED"
    | "PROCESSING"
    | "SENT"
    | "ERROR"
    | "VIRUS"
    | "SIGNED";

  /** Тип документа. Соответствует DocumentCodeEnum */
  documentCode?: DocumentCodeEnum;

  /** Описание причины непринятия файла */
  description?: string;

  /**
   * Дата загрузки
   * @format date-time
   */
  dateCreate?: string;
}

/**
 * Файл приложенный к анкете
 */
export interface CreditFormFileList {
  /** Файл */
  creditFormFiles?: CreditFormFile[];
}

/**
 * Объект ответа по скачиваемому файлу
 */
export interface DownloadFileResp {
  /** Контент */
  data?: string;
}

/**
 * Объект для ответа по списку заявок
 */
export interface CreditApplicationShort {
  /**
   * id кредита
   * @format uuid
   */
  id?: string;

  /** Название заявки */
  name?: string;

  /**
   * Номер заявки
   * @format int32
   */
  number?: number;

  /**
   * Срок кредита
   * @format int32
   */
  period?: number;

  /** Запрашиваемая сумма кредита */
  requestAmount?: number;

  /** Статус заявки */
  status?: string;

  /** Статус анкеты */
  statusForm?: string;

  /**
   * Дата создания заявки
   * @format date-time
   */
  date?: string;
}

/**
 * Список заявок
 */
export interface CreditApplicationShortListResp {
  /** Список заявок */
  applicationList?: CreditApplicationShort[];

  /** Список доступных бизнес-операций клиента */
  actorPermissions?: string[];

  /** Есть ли еще документы */
  hasMore?: boolean;
}

/**
 * Объект для детальной ингформации по заявке для фронта
 */
export interface CreditApplicationDetailResp {
  /** Объект для детальной информации по заявке для фронта */
  creditApplicationMainFieldsResp?: CreditApplicationMainFieldsResp;

  /**
   * Номер заявки
   * @format int32
   */
  number: number;

  /**
   * Дата создания заявки
   * @format date-time
   */
  date: string;

  /** Статус заявки */
  status: ApplicationStatusEnum;

  /** Описание статуса заявки */
  statusDescription?: ApplicationStatusDescEnum;

  /** Список доступных бизнес-операций клиента */
  actorPermissions?: string[];
}

/**
 * Доступность оформления заявки
 */
export enum ApplicationAvailableEnum {
  APPLICATIONS_AVAILABLE = "APPLICATIONS_AVAILABLE",
  APPLICATIONS_NOT_AVAILABLE = "APPLICATIONS_NOT_AVAILABLE",
  CLIENT_WITHOUT_CERT = "CLIENT_WITHOUT_CERT",
}

/**
 * Объект для ответа о доступности заявки на кредит
 */
export interface CreditApplicationAllowedResp {
  /** Доступность оформления заявки */
  applicationAllowed?: ApplicationAvailableEnum;

  /** Причина отказа */
  rejectionReasons?: string[];
}

import { HttpClient } from "../../client";
import { ContentType, RequestParams } from "../../client/types";

/**
 * @title Микросервис credits
 * @version 1.0
 * @license Все права защищены ООО РСХБ-ИНТЕХ
 * @baseUrl https://owb-ms-prd-credits.ndbo.dev.rshbdev.ru
 * @contact https://gitlab.rshbdev.ru/rshbintech/crft/dboul/ndbo/backend/owb-ms-prd-credits <info@rshbintech.ru> (https://sdlc.go.rshbank.ru/confluence/display/ndbouldev/Onboarding)
 */
export class Api<
  SecurityDataType extends unknown
> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags Анкета
     * @name SendApplicationFormToKkr
     * @summary Отправка заполненной анкеты в ККР
     * @request POST:/api/credits/v1/external/form/sendAppFormToKKR/{applicationId}
     */
    sendApplicationFormToKkr: (
      applicationId: string,
      params: RequestParams = {}
    ) =>
      this.request<KkrResponse, ValidationErrorInfo | GenericError>({
        path: `/api/credits/v1/external/form/sendAppFormToKKR/${applicationId}`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Анкета
     * @name SaveCreditForm
     * @summary Сохранение анкеты
     * @request POST:/api/credits/v1/external/form/save/{applicationId}
     */
    saveCreditForm: (
      applicationId: string,
      data: CreditForm,
      params: RequestParams = {}
    ) =>
      this.request<string, ValidationErrorInfo | GenericError>({
        path: `/api/credits/v1/external/form/save/${applicationId}`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Анкета
     * @name GetFilesExt
     * @summary Дозапрос файлов
     * @request POST:/api/credits/v1/external/form/files/ext/{applicationId}
     */
    getFilesExt: (applicationId: string, params: RequestParams = {}) =>
      this.request<EmptyResponse, GenericError>({
        path: `/api/credits/v1/external/form/files/ext/${applicationId}`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Файловое хранилище
     * @name UploadFile
     * @summary Загрузка файла
     * @request POST:/api/credits/v1/external/file-storage/upload
     */
    uploadFile: (data: UploadFileReq, params: RequestParams = {}) =>
      this.request<UploadFileResp, GenericError>({
        path: `/api/credits/v1/external/file-storage/upload`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Файловое хранилище
     * @name UploadSignature
     * @summary Загрузка подписи
     * @request POST:/api/credits/v1/external/file-storage/uploadSignature
     */
    uploadSignature: (data: UploadFileReq, params: RequestParams = {}) =>
      this.request<UploadFileResp, GenericError>({
        path: `/api/credits/v1/external/file-storage/uploadSignature`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Дадата
     * @name GetAddr
     * @summary Подсказки по адресу
     * @request POST:/api/credits/v1/external/dadata/addr
     */
    getAddr: (data: string, params: RequestParams = {}) =>
      this.request<AddresListResp, GenericError>({
        path: `/api/credits/v1/external/dadata/addr`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявка на кредит
     * @name UpdateCreditApplication
     * @summary Редактирование заявки
     * @request POST:/api/credits/v1/external/application/update/{applicationId}
     */
    updateCreditApplication: (
      applicationId: string,
      data: CreditApplicationMainFieldsResp,
      params: RequestParams = {}
    ) =>
      this.request<string, GenericError>({
        path: `/api/credits/v1/external/application/update/${applicationId}`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявка на кредит
     * @name SendApplicationToKkr
     * @summary Передача данных по кредитной заявке в ККР
     * @request POST:/api/credits/v1/external/application/sendAppToKKR/{applicationId}
     */
    sendApplicationToKkr: (applicationId: string, params: RequestParams = {}) =>
      this.request<KkrResponse, GenericError>({
        path: `/api/credits/v1/external/application/sendAppToKKR/${applicationId}`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявка на кредит
     * @name SaveCreditApplication
     * @summary Сохранение заявки
     * @request POST:/api/credits/v1/external/application/save
     */
    saveCreditApplication: (
      data: CreditApplicationMainFieldsResp,
      params: RequestParams = {}
    ) =>
      this.request<string, GenericError>({
        path: `/api/credits/v1/external/application/save`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Кредитные продукты
     * @name GetCreditProducts
     * @summary Список кредитных продуктов
     * @request GET:/api/credits/v1/external/products
     */
    getCreditProducts: (params: RequestParams = {}) =>
      this.request<CreditProductsListResp, GenericError>({
        path: `/api/credits/v1/external/products`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Кредиты, работа с фронтом
     * @name GetCredits
     * @summary Текущая информация о кредитах
     * @request GET:/api/credits/v1/external/loans
     */
    getCredits: (
      query: { position: number; size: number },
      params: RequestParams = {}
    ) =>
      this.request<CreditShortResponse, GenericError>({
        path: `/api/credits/v1/external/loans`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Кредиты, работа с фронтом
     * @name GetCreditDetails
     * @summary Детальная информация о кредите
     * @request GET:/api/credits/v1/external/loans/{productId}
     */
    getCreditDetails: (productId: string, params: RequestParams = {}) =>
      this.request<CreditDetailsInfo, GenericError>({
        path: `/api/credits/v1/external/loans/${productId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Кредиты, работа с фронтом
     * @name GetPaymentSchedule
     * @summary График платежей
     * @request GET:/api/credits/v1/external/loans/{productId}/payment-schedule
     */
    getPaymentSchedule: (productId: string, params: RequestParams = {}) =>
      this.request<CreditPaymentsSchedule, GenericError>({
        path: `/api/credits/v1/external/loans/${productId}/payment-schedule`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Анкета
     * @name GetCreditFormDetails
     * @summary Детальная информация о анкете
     * @request GET:/api/credits/v1/external/form/{applicationId}
     */
    getCreditFormDetails: (applicationId: string, params: RequestParams = {}) =>
      this.request<CreditForm, GenericError>({
        path: `/api/credits/v1/external/form/${applicationId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Анкета
     * @name IsRightToSign
     * @summary Проверка права подписи
     * @request GET:/api/credits/v1/external/form/is-right-to-sign
     */
    isRightToSign: (
      query: { applicationId: string },
      params: RequestParams = {}
    ) =>
      this.request<RightToSignResp, GenericError>({
        path: `/api/credits/v1/external/form/is-right-to-sign`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Анкета
     * @name GetCreditFormFiles
     * @summary Файлы прикрепленные к анкете
     * @request GET:/api/credits/v1/external/form/files/{applicationId}
     */
    getCreditFormFiles: (applicationId: string, params: RequestParams = {}) =>
      this.request<CreditFormFileList, GenericError>({
        path: `/api/credits/v1/external/form/files/${applicationId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Файловое хранилище
     * @name DownloadFile
     * @summary Выгрузка файла
     * @request GET:/api/credits/v1/external/file-storage/download/{fileId}
     */
    downloadFile: (fileId: string, params: RequestParams = {}) =>
      this.request<DownloadFileResp, GenericError>({
        path: `/api/credits/v1/external/file-storage/download/${fileId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявка на кредит
     * @name GetCreditsApplications
     * @summary Список заявок
     * @request GET:/api/credits/v1/external/application
     */
    getCreditsApplications: (
      query: { position: number; size: number },
      params: RequestParams = {}
    ) =>
      this.request<CreditApplicationShortListResp, GenericError>({
        path: `/api/credits/v1/external/application`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявка на кредит
     * @name GetCreditApplicationDetails
     * @summary Детальная информация о заявке
     * @request GET:/api/credits/v1/external/application/{applicationId}
     */
    getCreditApplicationDetails: (
      applicationId: string,
      params: RequestParams = {}
    ) =>
      this.request<CreditApplicationDetailResp, GenericError>({
        path: `/api/credits/v1/external/application/${applicationId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявка на кредит
     * @name ApplicationAllowed
     * @summary Доступность заявки
     * @request GET:/api/credits/v1/external/application/application-allowed
     */
    applicationAllowed: (params: RequestParams = {}) =>
      this.request<CreditApplicationAllowedResp, GenericError>({
        path: `/api/credits/v1/external/application/application-allowed`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Файловое хранилище
     * @name DeleteFile
     * @summary Удаление файла
     * @request DELETE:/api/credits/v1/external/file-storage/delete/{fileId}
     */
    deleteFile: (fileId: string, params: RequestParams = {}) =>
      this.request<EmptyResponse, GenericError>({
        path: `/api/credits/v1/external/file-storage/delete/${fileId}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),
  };
}

export const api = new Api();
